export { InlineFeedback } from './InlineFeedback';
export type { InlineFeedbackProps } from './InlineFeedback.types';
